import autoImporter from '@modules/auto-importer';

const requireService = require.context(
  './',
  true,
  /^\.\/(?!index\.(js|ts)$)((\w|-|\.)+\.(js|ts)$|.*\/index\.(js|ts)$)/
);

export const services = autoImporter(requireService);
